import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
import AdminHeader from './AdminHeader'
import { Autocomplete, InputLabel, TextField } from '@mui/material';
import { CustomerFindAll, PaymentFirstApi, PaymentInnerTableSave } from '../API/Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const AdminPayment = () => {

    const [customer_master, setCustomer_master] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [selectedCustomerName, setSelectedCustomerName] = useState('');
    const [selectedAmount, setSelectedAmount] = useState('');
    const [selectedBillNo, setSelectedBillNo] = useState('');
    const [show, setShow] = useState(false);
    const [additionalData, setAdditionalData] = useState([]);
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState(dayjs());
    const [month, setMonth] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = (item) => {
      setSelectedCustomerName(item.customer_name);
      setSelectedAmount(item.pay_amount);
      setSelectedBillNo(item.bill_no);
      setMonth(item.monthId)
      setCustomerId(item.customer_id);
      setShow(true);
    }
    const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;


    const Customerdata = () => {
        axios.get(`${CustomerFindAll}/${branchId}`)
            .then((res) => {
                if (res.data !== null) {
                    setCustomer_master(res.data);
                }
            })
            .catch((err) => {
                console.error("Failed to fetch customer data:", err);
                toast.error("Failed to fetch customer data. Please try again later.");
            });
    };

    const handleCustomerSelect = (customerId) => {
        setCustomerId(customerId);
        fetchAdditionalData(customerId);
    };

    const fetchAdditionalData = (customerId) => {
        axios.get(`${PaymentFirstApi}/${customerId}/${branchId}`)
            .then((res) => {
              if (res.data === "NOTFOUND") {
                console.warn("Additional data not found for customer:", customerId);
                toast.warn("Data not found.");
              }
             else { 
              setAdditionalData(res.data);
             }
                
            })
            .catch((err) => {
                console.error("Failed to fetch additional data:", err);
                toast.error("Failed to fetch additional data. Please try again later.");
            });
    };
    const savedata = () => {

      if (!customerId || !selectedBillNo || !date || !amount || !month) {
        toast.error('Please fill in all fields.');
        return;
    }
      const formattedDate = dayjs(date).format('DD/MM/YYYY');
      const data = {
          customer_id: customerId,
          bill_no: selectedBillNo,
          receive_date: formattedDate,
          receive_amount: amount,
          month: month,
          branch_id: branchId
      };
  
      console.log("data console......", data);
  
      axios.post(PaymentInnerTableSave, data)
          .then((res) => {
          
              if (res.data === "SAVED") {
                console.log("Response:", res.data);
                  toast.success('Data Saved Successfully');
                  handleClose();
                  setDate('');
                  setAmount('');
                  fetchAdditionalData(customerId);
              } else {
                  toast.error('Failed to save data. Please try again later.');
              }
          })
          .catch((err) => {
              console.error("Failed to save data:", err);
              toast.error("Failed to save data. Please try again later.");
          });
  };
  

  useEffect(() => {
      Customerdata();
      // fetchAdditionalData(customerId);
  }, []);

  return (
    <Container fluid>
    <Row>
      <AdminHeader />
    </Row>
    <Row className='dashBg'>
      {/* ====================== table =============== */}
      <Row className='m-0 p-0 px-md-5 py-1 mb-5 w-100' style={{ display: 'flex' }}>
        <Row className='pt-3'>
          <div className='heading text-black pt-3 pt-2 pt-md-2 mb-2 mb-md-4' style={{ fontSize: '27px', fontWeight: 'bold', textAlign: 'center' }}>
            <span style={{ color: 'rgb(255, 93, 0)', fontWeight: 350, textShadow: '3px 1px 5px rgb(180, 180, 180)' }}>Payment</span>
          </div>
        </Row>

        <Row>
        <Col md={4} className='mt-3'>
        <Autocomplete
                options={customer_master}
                getOptionLabel={(option) => option.customer_name}
                value={customer_master.find((item) => item.customer_id === customerId) || null}
                onChange={(event, newValue) => handleCustomerSelect(newValue ? newValue.customer_id : '')}
                renderInput={(params) => <TextField {...params} size='small' label="Select Customer" />}
            />
    </Col>
        </Row>

        <Row>
        <div style={{ overflowY: 'auto' }}>
            <div style={{ overflowX: 'auto' }}>
              <Table striped bordered hover size="sm" className='shadow mt-4' style={{ textAlign: "center" }}>
                <thead >
                  <tr >
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Sr.No</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Month</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Bill No</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Pay Amount</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Status</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'></th>
                  </tr>
                </thead>
                 <tbody>
                                        {additionalData
                                          .filter((item) => item.customer_id === customerId) 
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.month}</td>
                                                <td>{item.bill_no}</td>
                                                <td>{item.pay_amount}</td>
                                                <td>{item.status}</td>
                                                <td>
                                                    <button className='m-1' style={{ color: "orange", border: "0px", backgroundColor: "transparent" }}  onClick={() => handleShow(item)}>
                                                        <i style={{ color: "rgb(255, 93, 0)" }} className="fa-solid fa-plus"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
              </Table>
            </div>
          </div>
        </Row>


        {/* ================== Modal ==================== */}

        <Modal className='shadow rounded' show={show} onHide={handleClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor:"rgb(214, 234, 248)", color: "black" }} >
            <Modal.Title >

              <p style={{ fontSize: "15px" }} className='text-center mt-2'><b>Payment</b></p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form encType="multipart/form-data">
              <Row className='m-0 p-0'>
                <Col sm={12} md={12} className='mt-3'  style={{display:"flex"}}>
                  <Form.Label><h6 ><b>Customer Name:</b>&nbsp; &nbsp;  {selectedCustomerName}</h6></Form.Label>
                  {/* <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="text"
                    readOnly
                    value={selectedCustomerName}
                  /> */}
                </Col>

              

                <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>Bill No :</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    readOnly
                    value={selectedBillNo}
                  />
                </Col>

                <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>Amount :</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    readOnly
                    value={selectedAmount}
                  />
                </Col>

                <Col sm={12} md={6} className='mt-2 mb-3'>
              <Form.Label>
                <h6>
                  <b>Rec. date :</b>
                </h6>
              </Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      format="DD/MM/YYYY"
      label="Select Date"
      value={date}
      onChange={(newDate) => {
        console.log("date res", newDate);
        setDate(newDate);
      }}
      slotProps={{ textField: { size: 'small' } }}
    />
  </DemoContainer>
</LocalizationProvider>
            </Col>

            <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>Rec. Amt :</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Col>

              </Row>
              <Row className='mt-2 mb-3'>
                <Col style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      style={{
                        border: "0px",
                        backgroundColor: 'rgb(47, 79, 79)',
                        borderRadius: "15px",
                      }}
                      className="py-2 px-3 mx-2 shadow text-light"
                      type="submit"
                      onClick={savedata}
                    >
                      Save
                    </Button>
                </Col>
              </Row>
            </Form>


          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor:"rgb(214, 234, 248)",color:"black" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleClose}>
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>



        </Row>
        </Row>

        </Container>
  )
}

export default AdminPayment